import { Typography } from "antd"
import cls from "classnames"

import { remainingTime } from "../../../../Utils/utils"
import { creditRequestStatusTagMap } from "../../utils/creditsStatusMapping"

import "./CreditRequestStatus.less"

const { Text } = Typography

const CreditRequestStatus = ({ cr, className }) => {
  const status = cr?.request_status
  const tagType = creditRequestStatusTagMap[status] || "neutral"

  const time =
    status?.toLowerCase() === "requires proof" && cr?.["proof_deadline"]
      ? remainingTime(null, null, cr?.["proof_deadline"])
      : null

  const statusText = status === "Requires proof" && time ? `${status} • ${time}` : status

  return (
    <div className={cls("credit-request-status-tag", tagType, className)}>
      <Text strong>{statusText}</Text>
    </div>
  )
}

export default CreditRequestStatus
